export default "/assets/website/components/images/close.3dc0217a.svg";